export interface PatchInfo {
  v: string
  midpatches?: string[]
}

export const PATCHES: PatchInfo[] = [
  { v: "6.10", midpatches: ["6.10.1", "6.10.2"] },
  { v: "6.9", midpatches: ["6.9.1", "6.9.2"] },
  { v: "6.8", midpatches: ["6.8.2"] },
  { v: "6.7" },
  { v: "6.6" },
  { v: "6.5" },
  { v: "6.4" },
  { v: "6.3" },
  { v: "6.2" },
  { v: "6.1" },
  { v: "6.0" },
  { v: "5.10" },
  { v: "5.9" },
  { v: "5.8" },
  { v: "5.7" },
  { v: "5.6" },
  { v: "5.5" },
  { v: "5.4" },
  { v: "5.3" },
  { v: "5.2" },
  { v: "5.1" },
  { v: "5.0" },
  { v: "4.9" },
  { v: "4.8" },
  { v: "4.7" },
  { v: "4.6" },
  { v: "4.5" },
  { v: "4.4" },
  { v: "4.3" },
  { v: "4.2" },
  { v: "4.1" },
  { v: "4.0" },
  { v: "3.10" },
  { v: "3.9" },
  { v: "3.8" }
]
